import Axios from "axios"


export async function get_schedule_info(props) {

    const branch_id = props['branch_id']
    const event_id = props['event_id']
    const schedule_id = props['schedule_id']

    const result = await Axios.post("/schedule/info", {
        branch_id: branch_id,
        event_id: event_id,
        schedule_id: schedule_id
    })

    const data = result.data

    return data
}